// 点击区域上报
export enum AdVRActionType {
  NONE = '',
  // 广告主头像
  ADVERTISER_LOGO = '1002',
  // 广告主名称
  ADVERTISER_NAME = '1003',
  // 广告标题
  AD_TITLE = '1011',
  // 广告 图片/视频区域. AD_VIEW_AREA
  AD_VIEW = '1014',
  // 广告其他区域
  AD_VIEW_RIT = '1022',
  // 默认区域/其他区域
  AD_DETAIL = '1024',
  // 前贴全屏（横屏）下载广告banner
  LD_DOWNLOAD_BANNER = '1025',
  // 行动按钮, 二维码区域
  AD_ACTION_BUTTON = '1021',
  // 标签
  AD_SUP_TAG = '1045',
}

export enum AdExposureType {
  /** 原始曝光 */
  ORIGINAL = 1,
  /** 有效曝光 */
  EFFECTIVE = 2,
}

export enum AdVRPageId {
  V_QQ_SEARCH = 'page_search_result_web',
  HOME_CHANNEL = 'page_home_channel',
  SHORT_DRAMA = 'page_short_drama',
  AD_SPLASH = 'page_ad_splash',
  DETAIL = 'page_detail',
}

export enum AdVRElement {
  WHOLE_AD = 'whole_ad',
  POSTER = 'poster',
  AD_HEAD = 'ad_head',
  AD_NAME = 'ad_name',
  AD_TITLE = 'ad_title',
  AD_SECOND_TITLE = 'ad_second_title',
  POSTER_RLT = 'poster_rlt',
  AD_SOUND = 'ad_sound',
  NEXT_BUTTON = 'next_button',
  AD_ACTION = 'ad_action',
  AD_CLOSE = 'ad_close',
  CLOSE = 'close',
  QRCODE = 'qrcode',
  AD_SUP_TAG = 'ad_sup_tag',
}

export const AdVRTempParams = {
  WHOLE_AD: '{}',
  POSTER: '{}',
  AD_HEAD: '{}',
  AD_NAME: '{}',
  AD_TITLE: '{}',
  AD_SECOND_TITLE: '{}',
  POSTER_RLT: '{}',
  AD_SOUND: '{}',
  NEXT_BUTTON: '{}',
  AD_ACTION: '{}',
  AD_CLOSE: '{}',
  CLOSE: '{}',
  QRCODE: '{}',
  AD_SUP_TAG: '{}',
};

export enum AdVREvent {
  // 曝光
  IMP = 'dt_imp',
  // 点击
  CLICK = 'dt_clck',
  // 曝光结束
  IMP_END = 'dt_imp_end',
  // 原始曝光
  ORIGIN_EXPOSURE = 'originalexposure',
  // 有效曝光
  EFFECTIVE_EXPOSURE = 'effectiveexposure',
  // 视频开始
  VIDEO_START = 'videostart_ad',
  // 视频完成
  VIDEO_FINISH = 'videofinish_ad',
  // 视频暂停
  VIDEO_PAUSE = 'videopause_ad',
  // 打开小程序
  OPEN_MINI = 'open_mini',
  // 请求小程序授权
  MINI_AUTH_REQUEST = 'ad_mini_auth_request',
  // 小程序授权结果
  MINI_AUTH_RESULT = 'ad_mini_auth_result',
  // 广告自定义上报
  AD_TECH_PARAM_REPORT = 'ad_tech_param_report',
}

// 端内小程序上报事件
export enum AdMiniGameNativeVREvent {
  VR_MINI_OPEN = 'vr_mini_open',
  VR_MINI_AUTH_START = 'vr_mini_auth_start',
  VR_MINI_AUTH_END = 'vr_mini_auth_end',
}


export enum AdPlayerStatus {
  STOP = 0,
  PLAY = 1,
  PAUSE = 2,
}

export enum AdPlayReportType {
  // 手动播放
  PLAY = 1,
  // 暂停
  PAUSE = 2,
  // 手动续播
  RESUME = 3,
  // 播放完成
  END = 4,
  // 播放失败
  FAIL = 6,
  // 自动播放
  AUTO_PLAY = 7,
  // 打开声音
  UNMUTE = 8,
  // 关闭声音
  MUTE = 9,
  // 播放异常中断
  INTERRUPT = 10,
  // 自动重复播放
  AUTO_REPLAY = 13,
}

export type AdStopType = AdPlayReportType.END | AdPlayReportType.INTERRUPT;
export type AdPlayType = AdPlayReportType.AUTO_PLAY | AdPlayReportType.PLAY | AdPlayReportType.AUTO_REPLAY;

export enum AdPlayReportFailReason {
  NONE = 0,
  DOWNLOAD = 1,
  PLAY = 2,
  OTHER = 3,
}

export enum AdReportMonitorType {
  REQUEST_START = 0, // 请求开始
  REQUEST_SUCCESS = 1, // 请求成功
  REQUEST_ERROR = 2,
}
